import {
    DEALERAGENTPROFILE_SUCCESS,
    DEALERAGENTPROFILE_FAILED,
    RESET_DEALERAGENTPROFILE,
    LOADING_DEALERAGENTPROFILE,
    NETWORK_ERROR_DEALERAGENTPROFILE
} from '../types/index'

import { dealerServices } from "../../config/axios";

const resetDealerAgentProfile = () => {
    return { type: RESET_DEALERAGENTPROFILE };
};

const dealerAgentProfile = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERAGENTPROFILE });
    await dealerServices
        .post("agentProfile", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerGetAgentProfilesuccess(res.data));
                    break;
                default:
                    dispatch(dealerGetAgentProfileFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERAGENTPROFILE,
                payload: err
            });
        });
}

function dealerGetAgentProfilesuccess(data) {
    return {
        type: DEALERAGENTPROFILE_SUCCESS,
        payload: data
    };
}

function dealerGetAgentProfileFailed(data) {
    return {
        type: DEALERAGENTPROFILE_FAILED,
        payload: data
    };
}


export { resetDealerAgentProfile, dealerAgentProfile }